import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [
    {
      id: 1,
      title: "Frontend Developer",
      description:
        "I specialize in building scalable, high-performance web applications using JavaScript, TypeScript, React, and Redux for efficient state management. With 2+ years of experience, I have developed responsive and user-friendly interfaces, optimized performance, and integrated RESTful APIs and WebSockets for real-time data exchange.I am proficient in Docker for containerized deployments, CI/CD pipelines, and Agile methodologies (Scrum, Kanban) to ensure efficient project delivery. Additionally, I have experience with Material-UI, Tailwind CSS, and Auth0, making me a well-rounded Middle Frontend Developer capable of delivering scalable and maintainable solutions.",
      company: "JunoTech Solutions",
      date: "August 2023 - Present",
      icon: "work",
    },

    {
      id: 2,
      title: "DevOps engineer",
      description:
        "In this company  I delved into the crucial practices of software development and deployment automation, focusing on enhancing collaboration between development and operations teams. I acquired practical skills in using tools like Docker, Jenkins, and Kubernetes to facilitate continuous integration and deployment pipelines.",
      company: "Plazz.Ag",
      date: "September 2022 - June 2023",
      icon: "work",
    },
    {
      id: 3,
      title: "Frontend Developer",
      description:
        "As a junior front-end developer, I transformed complex designs into dynamic web pages, ensuring responsiveness and cross-browser compatibility. My responsibilities included website maintenance, content updates, and implementing design adjustments to enhance user experience. I was committed to learning new technologies and collaborating with team members across departments, contributing to innovative solutions and improved project outcomes.",
      company: "LLC DiGi,",
      date: "December 2021 - August 2022",
      icon: "work",
    },
  ],
};

const experienceSlice = createSlice({
  name: "experienceSlice",
  initialState,
  reducers: {},
});

export default experienceSlice.reducer;
